import { render, staticRenderFns } from "./OrgItemEdit.vue?vue&type=template&id=049d275a"
import script from "./OrgItemEdit.vue?vue&type=script&lang=js"
export * from "./OrgItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports